import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import CustomAlert from '../Common/CustomAlert';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const AssignMD: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [dateValue, setDateValue] = useState(''); 
    const [isLoading, setIsLoading] = useState(false);
    const [alertState, setAlertState] = useState({
        show: false,
        message: '',
        isSuccess: false 
    });

    const schoolCode = searchParams.get('SchoolCode');
    const familyCode = searchParams.get('FamilyCode');
    const login = searchParams.get('Login');
    const TeacherLogin = searchParams.get('TeacherLogin');

    const handleCloseAlert = () => {
        setAlertState(prev => ({ ...prev, show: false }));
        if (alertState.isSuccess) {
            window.close();
        }
    };

    const handleAssign = async () => {
        if (!dateValue || dateValue.length !== 10) {
            setAlertState({ show: true, message: "Please enter the date (dd/mm/yyyy).", isSuccess: false });
            return;
        }

        const parts = dateValue.split('/');
        if (parts.length !== 3) {
            setAlertState({ show: true, message: "Invalid date format.", isSuccess: false });
            return;
        }

        const [day, month, year] = parts;
        const formattedDate = `${year}-${month}-${day}`;

        setIsLoading(true);

        try {
            const payload = {
                school_code: schoolCode,
                family_code: familyCode,
                login: login,
                set_date: formattedDate,
                teacher_login: TeacherLogin
            };

            const response = await fetch(`${API_BASE_URL}api/assign_maths_doctor/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (data.status === 'success') {
                setAlertState({ show: true, message: "Maths Doctor assigned successfully.", isSuccess: true });
            } else {
                setAlertState({ show: true, message: data.message || "Failed to assign Maths Doctor.", isSuccess: false });
            }

        } catch (error) {
            console.error("Error assigning MD:", error);
            setAlertState({ show: true, message: "Failed to assign Maths Doctor. Please try again.", isSuccess: false });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={styles.body}>
            <div style={styles.wrapper}>
                <h1 style={styles.h1}>Assign Maths Doctor</h1>

                <div style={styles.setdate}>
                    <span style={styles.label}>Set Date: </span>
<input
    type="date"
    value={
        dateValue
            ? `${dateValue.split('/')[2]}-${dateValue.split('/')[1]}-${dateValue.split('/')[0]}`
            : ''
    }
    onChange={(e) => {
        const value = e.target.value; // yyyy-mm-dd

        if (value) {
            const [year, month, day] = value.split('-');
            setDateValue(`${day}/${month}/${year}`);
        } else {
            setDateValue('');
        }
    }}
    style={styles.textBox}
/>
                </div>

                <div style={styles.btnPlaceholder}>
                    <button 
                        onClick={handleAssign} 
                        style={styles.greenButton}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Wait...' : 'Assign'}
                    </button>

                    <button 
                        onClick={() => window.close()} 
                        style={styles.greenButton}
                    >
                        Cancel
                    </button>
                </div>
            </div>

            {alertState.show && (
                <CustomAlert 
                    message={alertState.message} 
                    onClose={handleCloseAlert} 
                />
            )}
        </div>
    );
};

const styles = {
    body: {
        backgroundColor: 'white',
        fontFamily: "'Trebuchet MS', Arial, Helvetica, sans-serif",
        fontSize: '8pt',
        position: 'absolute' as const,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: '10px',
        overflow: 'auto',
        boxSizing: 'border-box' as const
    },
    wrapper: {
        textAlign: 'left' as const, 
        padding: '30px',
        maxWidth: '50%',
        backgroundColor: '#f2f2f2',
        borderRadius: '8px',
    },
    h1: {
        fontSize: '18px',
        color: '#000000',
        fontWeight: 'bold' as const,
        textAlign: 'left' as const,
        borderBottom: 'none'
    },
    setdate: {
        marginBottom: '30px',
        paddingLeft: '5px' 
    },
    label: {
        fontFamily: "'Trebuchet MS', Arial, sans-serif",
        fontSize: '10pt',
        marginRight: '5px'
    },
    textBox: {
        fontFamily: "'Trebuchet MS', Arial, sans-serif",
        fontSize: '10pt',
        width: '70%',
        padding:"10px",
        height: '20px',
        paddingLeft: '2px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        color:"#877575"
        // boxSizing: 'border-box' as const
    },
    btnPlaceholder: {
        display: 'flex',
        gap: '10px',
        marginTop: '20px',
        paddingLeft: '5px'
    },
    greenButton: {
        backgroundColor: '#4caf50',
        color: 'white',
        fontFamily: "'Trebuchet MS', Arial, sans-serif",
        fontSize: '10pt',           
        fontWeight: 'bold' as const,
        border: 'none',
        borderRadius: '4px',
        height: '40px',
        width: '40%',
        cursor: 'pointer',
        padding: 0
    }
};

export default AssignMD;